import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { DropdownFilterComponent } from '@irb-common/components/dropdown-filter/dropdown-filter.component';
import { MatchComponent } from '@irb-common/components/grid/renderers/match.cell.component';
import {MatchCustomTooltipComponent} from "@irb-common/components/grid/renderers/match-cutom-tooltip.component";

@Injectable({
    providedIn: 'root'
})
export class DropdownFilterGridLayoutService implements GridLayoutService<DropdownFilterComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {
            "MatchComponent": MatchComponent,
            "MatchCustomTooltipComponent": MatchCustomTooltipComponent
        };
    }

    getColumnDefs() {
        return [{
            headerName: 'Name',
            field: 'name',
            suppressFloatingFilterButton: true,
            cellClass: (params: any) => { 
                return (params.data.class) ? params.data.class : '';
            },
            cellRendererSelector: (params: any) => {
                if (params.data.customToolTipWhenDisabled) {
                    return {
                        component: 'MatchCustomTooltipComponent'
                    }
                } else {
                    return {
                        component: 'MatchComponent'
                    };
                }
            },
            sortable: false,
            flex: 1
        }];
    }
}
